export default "__VITE_ASSET__CvgYuK8m__"